export const ACTIVATE_LOADER = "ACTIVATE_LOADER";
export const DEACTIVATE_LOADER = "DEACTIVATE_LOADER";
export const USER_CONFIG = "USER_CONFIG";
export const SET_GLOBAL_INFO = "SET_GLOBAL_INFO";
export const SET_USER_INFO = "SET_USER_INFO";
export const SET_INTERFACE_INFO = "SET_INTERFACE_INFO";
export const SET_PROFILE_SLIDE_PANE = "SET_PROFILE_SLIDE_PANE";
export const SET_USER_INFO_KEY_VALUE = "SET_USER_INFO_KEY_VALUE";
export const LOGOUT_USER = "LOGOUT_USER";
export const RESET_NAVIGATION_TO_HOME = "RESET_NAVIGATION_TO_HOME";
export const SET_ACTIVE_MENU = "SET_ACTIVE_MENU";
export const SET_ACTIVE_KNOWLEDGE_ID = "SET_ACTIVE_KNOWLEDGE_ID";
export const SET_ACTIVE_APP = "SET_ACTIVE_APP";
export const SET_PROJECT_CONFIG = "SET_PROJECT_CONFIG";
export const SET_FUNCTIONS_AND_GOALS = "SET_FUNCTIONS_AND_GOALS";
export const SET_ROLE_LIST = "SET_ROLE_LIST";
